import { SHORTCUT_LIST_CONTROL } from '@savgroup-front-common/constants';
import { useShortCut } from '@savgroup-front-common/core/src/hooks';

const useFocusOnShortCut = (callback: () => void): void => {
  useShortCut({ callback, codes: SHORTCUT_LIST_CONTROL.SEARCH_OPEN });
};

export default useFocusOnShortCut;
